import { useState, useEffect } from 'react'
import { getAdminContent, updateContent } from '@/utils/api'

const contentSections = [
  { page: 'inicio', title: 'Página de Inicio' },
  { page: 'quienes-somos', title: 'Quienes Somos' },
  { page: 'consultas', title: 'Consultas' },
  { page: 'medicina-preventiva', title: 'Medicina Preventiva' },
  { page: 'atencion-por-especie', title: 'Atención por Especie' },
  { page: 'cirugia', title: 'Cirugía' },
  { page: 'internacion-y-cuidados', title: 'Internación y Cuidados' },
  { page: 'enfermeria', title: 'Enfermería' },
  { page: 'laboratorio-basico', title: 'Laboratorio Básico' },
  { page: 'dermatologia', title: 'Dermatología' },
  { page: 'odontologia', title: 'Odontología' },
  { page: 'produccion-animal', title: 'Producción Animal' },
  { page: 'bromatologia', title: 'Bromatología' },
  { page: 'bienestar-y-asesoramiento', title: 'Bienestar y Asesoramiento' },
  { page: 'cursos', title: 'Cursos' },
  { page: 'asistente-ia', title: 'Asistente IA' },
  { page: 'contacto', title: 'Contacto' },
]

function ContentEditor() {
  const [selectedPage, setSelectedPage] = useState<string>('inicio')
  const [content, setContent] = useState<Record<string, unknown>>({})
  const [isSaving, setIsSaving] = useState(false)
  const [saveSuccess, setSaveSuccess] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const loadContent = async () => {
      setError(null)
      try {
        const data = await getAdminContent()
        const pageContent = data.pages.find((p) => p.page_slug === selectedPage)
        if (pageContent) {
          setContent(pageContent.content_json)
        } else {
          setContent({})
        }
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Error al cargar el contenido')
      }
    }
    loadContent()
  }, [selectedPage])

  const handleSave = async () => {
    setIsSaving(true)
    setSaveSuccess(false)
    setError(null)

    try {
      await updateContent(`${selectedPage}.main`, content)

      setSaveSuccess(true)
      setTimeout(() => setSaveSuccess(false), 3000)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al guardar el contenido')
    } finally {
      setIsSaving(false)
    }
  }

  const selectedSection = contentSections.find((s) => s.page === selectedPage)

  return (
    <div className="min-h-screen">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-text-primary">Gestión de Contenido</h1>
        <p className="text-text-secondary mt-1">
          Editar contenido de: {selectedSection?.title || 'Página'}
        </p>
      </div>

      <div className="glass-card rounded-xl p-6 shadow-sm">
        {error && (
          <div className="mb-6 p-4 bg-error/10 text-error rounded-lg border border-error/20">
            {error}
          </div>
        )}

        <div className="mb-6">
          <label className="block text-sm font-semibold text-text-primary mb-2">
            Seleccionar página
          </label>
          <select
            value={selectedPage}
            onChange={(e) => setSelectedPage(e.target.value)}
            className="w-full md:w-1/2 px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary transition"
          >
            {contentSections.map((section) => (
              <option key={section.page} value={section.page}>
                {section.title}
              </option>
            ))}
          </select>
        </div>

        <div className="mb-6">
          <label className="block text-sm font-semibold text-text-primary mb-2">
            Contenido (JSON)
          </label>
          <textarea
            value={JSON.stringify(content, null, 2)}
            onChange={(e) => {
              try {
                setContent(JSON.parse(e.target.value))
              } catch {
                // Invalid JSON, ignore
              }
            }}
            rows={12}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg font-mono text-sm focus:ring-2 focus:ring-primary focus:border-primary transition"
          />
        </div>

        {saveSuccess && (
          <div className="mb-6 p-4 bg-success/10 text-success rounded-lg border border-success/20">
            Contenido guardado correctamente
          </div>
        )}

        <div className="flex justify-end">
          <button
            onClick={handleSave}
            disabled={isSaving}
            className="bg-primary text-white px-6 py-2.5 rounded-lg font-medium hover:bg-primary-dark transition disabled:opacity-50 shadow-sm"
          >
            {isSaving ? (
              <span className="flex items-center">
                <i className="ph ph-spinner animate-spin mr-2"></i>
                Guardando...
              </span>
            ) : (
              'Guardar cambios'
            )}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ContentEditor